import { useTranslations } from '@vocab/react';
import {
  Box,
  ButtonIcon,
  IconDownload,
  IconEnlarge,
  IconZoomIn,
  IconZoomOut,
  Inline,
} from 'braid-design-system';
import type { FC, MouseEvent } from 'react';

import translations from './.vocab';

interface Props {
  isExpanded: boolean;
  onCollapse: () => void;
  onExpand: () => void;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onDownload: () => void;
}

const Toolbar: FC<Props> = ({
  isExpanded = false,
  onCollapse,
  onExpand,
  onZoomIn,
  onZoomOut,
  onDownload,
}) => {
  const { t } = useTranslations(translations);
  const renderScreenSizeControl = () => {
    if (isExpanded) {
      return (
        <ButtonIcon
          id="collapse-document-viewer"
          icon={<IconEnlarge active />}
          label={t('Collapse document')}
          onClick={onCollapse}
        />
      );
    }

    return (
      <ButtonIcon
        id="expand-document-viewer"
        icon={<IconEnlarge />}
        label={t('Expand document')}
        onClick={onExpand}
      />
    );
  };

  return (
    <Box
      display="flex"
      justifyContent="flexStart"
      padding="xsmall"
      paddingTop="none"
      paddingBottom="medium"
    >
      <Inline space="small" align="right">
        {renderScreenSizeControl()}
        <ButtonIcon
          id="zoom-out-document-viewer"
          icon={<IconZoomOut />}
          label={t('Zoom out')}
          onClick={onZoomOut}
        />
        <ButtonIcon
          id="zoom-in-document-viewer"
          icon={<IconZoomIn />}
          label={t('Zoom in')}
          onClick={onZoomIn}
        />
        <ButtonIcon
          id="download-document-viewer"
          icon={<IconDownload />}
          label={t('Download document')}
          onClick={(event: MouseEvent<HTMLButtonElement>) => {
            if (!event.detail || event.detail === 1) {
              // Prevents the second click on the button
              onDownload();
            }
          }}
        />
      </Inline>
    </Box>
  );
};

export default Toolbar;
